import { MotivoCancelamentoMarcacao } from "../marcacao/motivo-cancelamento-marcacao";

export class InformacaoCancelamentoMarcacaoDTO {

    motivoCancelamentoMarcacao: MotivoCancelamentoMarcacao | undefined;

    constructor() {
    }
}
